import * as Yup from "yup";
import { RELATIONSHIP_OPTIONS } from "../../../../../../constants/leadDropdown";
import {
  emailValidationRegex,
  faxNumberRegex,
  websiteUrlRegex,
  zipCodeRegex,
} from "../../../../../../constants/regexStrings";
import phoneValidation from "../../../../../../common/components/phone-number-input-component/phone-validation";
import { isOnlyCountryCode } from "../../../../../../utils/utils";

export const validationSchema = (isEditMode: boolean) =>
  Yup.object().shape({
    leadValue: Yup.string()
      .matches(/^\d+(\.\d+)?$/, "lead value format is invalid")
      .max(15, "Lead value cannot be more than 15 characters").nullable(),
    secondaryEmail: Yup.string()
      .matches(emailValidationRegex, "Please enter a valid Email address")
      .max(150, "Secondary Email cannot be more than 150 characters")
      .nullable()
      .test(
        "notEmptyWhenProvided",
        "Secondary Email cannot be same as Primary Email",
        function (value) {
          const { email } = this.parent;
          if (value && email && email === value) {
            return false;
          }

          return true;
        },
      ),

    secondaryPhoneNumber: Yup.string()
      .test(
        "is-valid-phone",
        "Please enter a valid phone number",
        function (value: any) {
          if (isOnlyCountryCode(value)) {
            return true;
          }
          return phoneValidation(value);
        },
      )
      .nullable()
      .test(
        "not-same-as-primary",
        "Secondary Phone Number cannot be same as Primary Phone Number",
        function (value) {
          const { primaryPhoneNumber } = this.parent;

          // Skip the comparison if both primary and secondary are country codes
          if (
            isOnlyCountryCode(primaryPhoneNumber) &&
            isOnlyCountryCode(value)
          ) {
            return true; // Don't compare country codes only
          }

          if (value && primaryPhoneNumber && value === primaryPhoneNumber) {
            return false;
          }
          return true;
        },
      ),
    website: Yup.string()
      .matches(websiteUrlRegex, "Enter a valid website URL")
      .nullable()
      .max(150, "Website cannot be more than 150 characters"),
    socialLeadId: Yup.string()
      .nullable()
      .max(100, "Social lead id cannot be more than 100 characters"),
    fax: Yup.string()
      .nullable()
      .test("is-valid-fax", "Please enter a valid fax number", (value) => {
        if (!value || isOnlyCountryCode(value)) {
          return true;
        }
        return phoneValidation(value);
      }),
    contactPersonPhoneNumber: Yup.string()
      .nullable()
      .test(
        "is-valid-contact-phone",
        "Please enter a valid phone number",
        (value) => {
          if (!value || isOnlyCountryCode(value)) {
            return true;
          }
          return phoneValidation(value);
        },
      ),
    description: Yup.string()
      .max(200, "Description cannot be more than 150 characters")
      .nullable(),
    relationship: Yup.string()
      .oneOf(
        RELATIONSHIP_OPTIONS.map((opt) => opt.value),
        "Please select a valid relationship"
      ),
  });
